/* tslint:disable */
/* eslint-disable */
/**
 * fantasy-dynasty-app
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DraftPick } from '../model';
// @ts-ignore
import { EventActivity } from '../model';
/**
 * DraftApi - axios parameter creator
 * @export
 */
export const DraftApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * retreives the draft pick with the given id
         * @param {string} [draftPickId] A unique identifier for a draft pick
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPick: async (draftPickId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/draftPicks/{draftPickId}`
                .replace(`{${"draftPickId"}}`, encodeURIComponent(String(draftPickId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all event history associated with a draft pick
         * @param {string} [draftPickId] A unique identifier for a draft pick
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPickHistory: async (draftPickId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/draftPicks/{draftPickId}/eventHistory`
                .replace(`{${"draftPickId"}}`, encodeURIComponent(String(draftPickId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DraftApi - functional programming interface
 * @export
 */
export const DraftApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DraftApiAxiosParamCreator(configuration)
    return {
        /**
         * retreives the draft pick with the given id
         * @param {string} [draftPickId] A unique identifier for a draft pick
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftPick(draftPickId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftPick>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftPick(draftPickId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all event history associated with a draft pick
         * @param {string} [draftPickId] A unique identifier for a draft pick
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftPickHistory(draftPickId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventActivity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftPickHistory(draftPickId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DraftApi - factory interface
 * @export
 */
export const DraftApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DraftApiFp(configuration)
    return {
        /**
         * retreives the draft pick with the given id
         * @param {string} [draftPickId] A unique identifier for a draft pick
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPick(draftPickId?: string, options?: any): AxiosPromise<DraftPick> {
            return localVarFp.getDraftPick(draftPickId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all event history associated with a draft pick
         * @param {string} [draftPickId] A unique identifier for a draft pick
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPickHistory(draftPickId?: string, options?: any): AxiosPromise<Array<EventActivity>> {
            return localVarFp.getDraftPickHistory(draftPickId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DraftApi - object-oriented interface
 * @export
 * @class DraftApi
 * @extends {BaseAPI}
 */
export class DraftApi extends BaseAPI {
    /**
     * retreives the draft pick with the given id
     * @param {string} [draftPickId] A unique identifier for a draft pick
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DraftApi
     */
    public getDraftPick(draftPickId?: string, options?: AxiosRequestConfig) {
        return DraftApiFp(this.configuration).getDraftPick(draftPickId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all event history associated with a draft pick
     * @param {string} [draftPickId] A unique identifier for a draft pick
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DraftApi
     */
    public getDraftPickHistory(draftPickId?: string, options?: AxiosRequestConfig) {
        return DraftApiFp(this.configuration).getDraftPickHistory(draftPickId, options).then((request) => request(this.axios, this.basePath));
    }
}
